/**
 * Nomes das colunas de técnico do filtro atual do Board.
 * Usa a lista explícita em tecnico; se vazia, deriva de coordenador/área (igual ao sync automático).
 */
export function hasActiveBoardTeamFilters(filters) {
  return (
    (Array.isArray(filters?.coordenador) && filters.coordenador.length > 0) ||
    (Array.isArray(filters?.area) && filters.area.length > 0) ||
    (Array.isArray(filters?.tecnico) && filters.tecnico.length > 0)
  );
}

export function getVisibleBoardTechnicianNames(filters, teamData) {
  const fromTecnico = Array.isArray(filters?.tecnico)
    ? filters.tecnico.map((n) => (n != null ? String(n).trim() : '')).filter(Boolean)
    : [];
  if (fromTecnico.length > 0) return fromTecnico;

  const names = [];
  const seen = new Set();
  const push = (nome) => {
    const n = nome != null ? String(nome).trim() : '';
    if (!n || seen.has(n)) return;
    seen.add(n);
    names.push(n);
  };

  const areas = teamData?.areas || [];
  const tecnicos = teamData?.tecnicos || [];
  const coords = teamData?.coordenadores || [];

  (filters?.coordenador || []).forEach((coordenadorNome) => {
    const coord = coords.find((c) => c.nome === coordenadorNome);
    if (!coord) return;
    areas
      .filter((area) => area.coordenadorId === coord.id)
      .forEach((area) => {
        tecnicos.filter((tec) => tec.areaId === area.id).forEach((tec) => push(tec.nome));
      });
  });

  (filters?.area || []).forEach((areaNome) => {
    const area = areas.find((a) => a.nome === areaNome);
    if (!area) return;
    tecnicos.filter((tec) => tec.areaId === area.id).forEach((tec) => push(tec.nome));
  });

  return names;
}

/**
 * Se coordenador/área já está marcado e tecnico ainda está vazio (equipe chegou depois do clique),
 * devolve os nomes para gravar no filtro. Null = nada a hidratar.
 */
export function getHydratedBoardFilterTechnicians(filters, teamData) {
  const fromTecnico = Array.isArray(filters?.tecnico)
    ? filters.tecnico.map((n) => (n != null ? String(n).trim() : '')).filter(Boolean)
    : [];
  if (fromTecnico.length > 0) return null;
  const hasParent =
    (Array.isArray(filters?.coordenador) && filters.coordenador.length > 0) ||
    (Array.isArray(filters?.area) && filters.area.length > 0);
  if (!hasParent || !teamData?.tecnicos?.length) return null;
  const names = getVisibleBoardTechnicianNames(filters, teamData);
  return names.length ? names : null;
}
